import { Component, EventEmitter, Input, Output } from '@angular/core';

import { ICheckboxSelectionData } from '@app/eds';

export type checkboxCardKeyValueType = {
  key: string;
  value: string;
};

@Component({
  selector: 'app-checkbox-card',
  templateUrl: './checkbox-card.component.html',
  styleUrls: ['./checkbox-card.component.scss']
})
export class CheckboxCardComponent {
  // Unique Id for the checkbox.
  @Input() checkboxId!: string;

  // Details to be displayed on the card.
  @Input() cardData!: checkboxCardKeyValueType[];

  // Boolean to specify if the checkbox is checked.
  @Input() isChecked = false;

  // Event Emitter to emit an event when the checkbox is checked or unchecked.
  @Output() checkBoxCheck: EventEmitter<ICheckboxSelectionData> =
    new EventEmitter<ICheckboxSelectionData>();

  /**
   * This function is called when the checkbox is checked or unchecked.
   * Emits an event with the details of the checkbox which can be used by the parent component.
   */
  onCheck = (checkboxDetails: ICheckboxSelectionData) => {
    this.isChecked = checkboxDetails?.isCheckedBool || this.isChecked;
    this.checkBoxCheck.emit(checkboxDetails);
  };
}
